import './index.css';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Routes, Route } from 'react-router-dom';
import Navbar from './pages/Navbar/Navbar';
import Home from './pages/Home/Home';
import About from './pages/About/About';
import Posts from './pages/Posts/Posts';
import SinglePost from './pages/Posts/SinglePost';
import Categories from './pages/Categories/Categories';
import SingleCategory from './pages/Categories/SingleCategory';
import Contributors from './pages/Contributors/Contributors';
import SingleContributor from './pages/Contributors/SingleContributor';
import PageDoesNotExist from './pages/404/404';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <Navbar/>
      <Routes>
        <Route path='*' element={<PageDoesNotExist/>} />
        <Route path='/' element={<Home/>} />
        <Route path='/posts' element={<Posts/>} />
        <Route path='/posts/:slug' element={<SinglePost/>} />
        <Route path='/categories' element={<Categories/>} />
        <Route path='/categories/:slug' element={<SingleCategory/>} />
        <Route path='/contributors' element={<Contributors/>} />
        <Route path='/contributors/:slug' element={<SingleContributor/>} />
        <Route path='/about' element={<About/>} />
        
      </Routes>
  </BrowserRouter>
);